import React, { useState, useEffect, useRef } from "react";
import "./uniqueidgeneration.scss";
import Sidebar from "../Sidebar";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { encode } from "base-64";
import Header from "../../component/loaderComponent/Header/Header";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import { notify } from '../../services/notification';
import { constant } from "../../constants/constant";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { HTTP_STATUS } from "../../constants/httpsStatus/httpsStatus";
import { HiMenu, HiX } from "react-icons/hi";
import { FaFileExcel, FaPlus } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import useMobileView from "../../constants/useMobileView";
import { pageUniqueIdGenerationActionAction, searchUniqueIdGenerationAction, uniqueIdListAction } from "../../actions/uniqueIdGenerationAction";

function UniqueIdGenerationList() {
  const searchdata = useSelector((state) => state?.UniqueIdGeneration);
  const pagedata = useSelector((state) => state?.uniqueIdGenerationPage);

  const [startIndex, setStartIndex] = useState(1);
  const [page, setPage] = useState(pagedata?.uniqueIdGenerationPageData?.page || 1);
  const [isLoading, setLoading] = useState(false);
  const [uniqueIdList, setUniqueIdList] = useState([]);
  const [paginationListcount, setPaginationListcount] = useState(0);
  const [checkDate, setCheckDate] = useState(null);
  const [state, setDataState] = useState({
    status: searchdata?.uniqueIdGenerationSearchdata?.data?.value || "",
    fromDate: searchdata?.uniqueIdGenerationSearchdata?.data?.fromDate || "",
    toDate: searchdata?.uniqueIdGenerationSearchdata?.data?.toDate || "",
  });
  
  const [count, setCount] = useState(1);
  const { isSidebarOpen, toggleSidebar } = useMobileView();
  const prevStatus = useRef("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    getUniqueIdList();
  }, [page]);

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (error) {
      return dateString;
    }
  };

  async function getUniqueIdList() {
    setLoading(true);
    const fromDate = state?.fromDate || "";
    const toDate = state?.toDate || "";
    const status = state?.status || prevStatus.current;

    try {
      const response = await dispatch(uniqueIdListAction(page, status, fromDate, toDate));

      const newStartIndex = (page - 1) * 10 + 1;
      setStartIndex(newStartIndex);
      
      if (response?.status === HTTP_STATUS.SUCCESS) {
        
        // Fixed data structure access based on API response
        const responseData = response?.data?.data || response?.data;
        const totalCount = responseData?.count || 0;
        const dataList = responseData?.results?.data || [];
        
        setCount(Math.ceil(totalCount / 10));
        setUniqueIdList(dataList);
        setPaginationListcount(totalCount);
      } else {
        setUniqueIdList([]);
        setPaginationListcount(constant.defaultPageZero);
      }
    } catch (error) {
      console.error("Error fetching unique ID list:", error);
      setUniqueIdList([]);
      setPaginationListcount(constant.defaultPageZero);
      notify.error("Failed to fetch unique ID list.");
    }
    setLoading(false);
  }

  const handleChange = (evt) => {
    const value = evt.target.value.trim();
    prevStatus.current = state?.status;
    setDataState({
      ...state,
      status: value.replace(/^ +/gm, ''),
    });
     if (value.length === 0) {
      window.location.reload()
    }
  };

  const handleDateChange = (evt) => {
    const { name, value } = evt.target;
    const today = new Date().toISOString().split("T")[0];

    if (value > today) {
      notify.error("Future dates are not allowed.");
      return;
    }

    setCheckDate(true);

    if (name === "fromDate") {
      const maxDate = new Date(value);
      maxDate.setDate(maxDate.getDate() + 31);
      setDataState(prevState => ({
        ...prevState,
        toDate: prevState.toDate && prevState.toDate > maxDate.toISOString().split("T")[0] ? "" : prevState.toDate,
        [name]: value,
      }));
    } else if (name === "toDate") {
      setDataState(prevState => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handlePagiChange = (event, value) => {
    setPage(value);
  };

  async function searchData() {
    setLoading(true);
    prevStatus.current = state?.status;
    
    const searchdata = {
      value: state?.status,
      fromDate: state?.fromDate,
      toDate: state?.toDate,
    };
    
    dispatch(searchUniqueIdGenerationAction(searchdata));
    const InitialPage = 1;
    
    if (page !== 1) {
      dispatch(pageUniqueIdGenerationActionAction(1));
      setPage(1);
    }

    try {
      const response = await dispatch(uniqueIdListAction(InitialPage || page, state?.status, state?.fromDate, state?.toDate));
      
      if (response && (response.status === HTTP_STATUS.SUCCESS || response.status === HTTP_STATUS.CREATED)) {
        // Fixed data structure access
        const responseData = response?.data?.data || response?.data;
        const totalQueries = responseData?.count || constant.defaultPageZero;
        const dataList = responseData?.results?.data || [];
        
        setCount(Math.ceil(totalQueries / 10));
        setUniqueIdList(dataList);
        setPaginationListcount(totalQueries);
      } else {
        setUniqueIdList([]);
        setPaginationListcount(constant.defaultPageZero);
      }
    } catch (error) {
      console.error("Error searching data:", error);
      setUniqueIdList([]);
      setPaginationListcount(constant.defaultPageZero);
    }
    setLoading(false);
  }

  const downloadUniqueIdList = (item) => {
    if (!item?.file_link) {
      notify.error('Download link not available.');
      return;
    }

    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = item.file_link;
    link.download = `UniqueID_${item.part_category?.part_category_code}_${item.cap_color?.cap_colour_code}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    notify.success('Download started successfully!');
  };

  const generateUniqueId = () => {
    navigate('/generateuniqueid');
  };

  const uniqueIdDetails = (Id) => {
    const encodeid = encode(Id);
    navigate(`/viewuniqueid/${encodeid}`);
  };

  const isDisable = () => {
    if (checkDate) {
      return !(state.toDate && state.fromDate);
    }
    return !state.status;
  };

  const startItem = (!uniqueIdList || uniqueIdList.length === 0)
    ? 0
    : (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, paginationListcount);

  return (
    <div className="unique-id-generation">
      <div className="unique-id-container">
        <div className="unique-id-content">
          <Header title="TRU4 QR Codes Unique ID Generation" />

          {isLoading ? (
            <Loader />
          ) : (
            <div className="unique-id-main">
              <div className="unique-id-actions">
                <div className="unique-id-search-actions">
                  <div className="unique-id-filters">
                    <select
                      name="status"
                      className="unique-id-dropdown"
                      value={state?.status}
                      onChange={handleChange}
                    >
                      <option value="">Status</option>
                      <option value="SUCCESS">Success</option>
                      <option value="FAILED">Failed</option>
                      <option value="PENDING">Pending</option>
                      <option value="IN_PROGRESS">In Progress</option>
                    </select>

                    <div className="unique-id-dates">
                      <div className="unique-id-date-container">
                        <label className="unique-id-date-label">From Date</label>
                        <input
                          type="date"
                          placeholder="From Date"
                          name="fromDate"
                          value={state.fromDate}
                          max={new Date().toISOString().split("T")[0]}
                          onChange={handleDateChange}
                          className="unique-id-date-input"
                        />
                      </div>
                      <div className="unique-id-date-container">
                        <label className="unique-id-date-label">To Date</label>
                        <input
                          type="date"
                          placeholder="To Date"
                          name="toDate"
                          value={state.toDate}
                          min={state.fromDate}
                          max={new Date().toISOString().split("T")[0]}
                          onChange={handleDateChange}
                          className="unique-id-date-input"
                        />
                      </div>
                    </div>
                    <div>
                      <button
                        className="unique-id-search-button"
                        disabled={isDisable()}
                        onClick={searchData}
                      >
                        Search
                      </button>
                    </div>
                  </div>

                  <div className="unique-id-buttons">
                    <button
                      className="unique-id-generate-button"
                      onClick={generateUniqueId}
                    >
                      Generate Unique ID
                    </button>
                  </div>
                </div>
              </div>

              {uniqueIdList && uniqueIdList.length > 0 ? (
                <div className="unique-id-table-container">
                  <table className="unique-id-table">
                    <thead className="unique-id-tableheader">
                      <tr>
                        <th>S.NO.</th>
                        <th>Part Category</th>
                        <th>Cap Color</th>
                        <th>Special Code</th>
                        <th>Number of Codes</th>
                        <th>Status</th>
                        <th>Requested At</th>
                        <th>Processed At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {uniqueIdList.map((item, index) => (
                        <tr key={index}>
                          <td>{startIndex + index}</td>
                          <td>{item?.part_category?.part_category_name || "-"}</td>
                          <td>{item?.cap_color?.cap_colour_name || "-"}</td>
                          <td>{item?.special_code || "-"}</td>
                          <td>{item?.number_of_codes || "-"}</td>
                          <td>
                            <span className={`status-badge status-${item?.status?.toLowerCase()}`}>
                              {item?.status || "-"}
                            </span>
                          </td>
                          <td>{formatDate(item?.requested_at)}</td>
                          <td>{formatDate(item?.processed_at)}</td>
                          <td>
                            {item?.status === "SUCCESS" && item?.file_link ? (
                              <button
                                className="unique-id-download-button"
                                onClick={() => downloadUniqueIdList(item)}
                              >
                                <FiDownload /> Download
                              </button>
                            ) : (
                              <span className="unique-id-empty-action">-</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="unique-id-no-data">
                  <NoDataFound />
                </div>
              )}

              {paginationListcount > 0 && (
                <div className="unique-id-pagination">
                  <Stack spacing={2}>
                    <Pagination
                      count={count}
                      className="unique-id-pagination-controls"
                      page={page}
                      size="medium"
                      defaultPage={1}
                      color="primary"
                      onChange={handlePagiChange}
                    />
                  </Stack>
                  <div className="unique-id-count">
                    <b>
                      <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                    </b>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default UniqueIdGenerationList;